// Drop-in <script> entry point.
//
// Deliberately imports neither the realtime client nor the markdown renderer.
// Both are fetched from sibling chunks the first time they are actually
// needed, so a visitor who never clicks pays only for this shell.
//
//   <script src="https://…/agents.js"></script>
//   <speechify-agent agent-id="agent_01HS..."></speechify-agent>

import { registerCustomElement } from "./element.js";
import { publishWidgetVersion } from "./version.js";
import { loadConnect } from "./lazy.js";
import type { AgentHandle, StartAgentOptions } from "./types.js";

// The drop-in path is the one support actually meets, so the build identity
// has to be readable here too, not only in the module build.
publishWidgetVersion();
registerCustomElement();

/**
 * Programmatic entry for pages that do not want the default UI. Resolves the
 * realtime client on first use, so calling it is what pulls the chunk.
 */
export async function startAgent(opts: StartAgentOptions): Promise<AgentHandle> {
  const connect = await loadConnect();
  return connect(opts);
}

export { isWidgetError, WidgetError } from "./errors.js";
export type { WidgetErrorCode } from "./errors.js";
export type {
  AgentHandle,
  AgentMessage,
  AgentStatus,
  SessionOverrides,
  SessionProvider,
  StartAgentOptions,
  ToolHandler,
} from "./types.js";
